import React from 'react';

const IconMobileGrid3x = props => (
  <svg width="31px" height="31px" viewBox="0 0 31 31" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-332.000000, -163.000000)"
        stroke="#585858"
        strokeWidth="1.1"
      >
        <g transform="translate(332.000000, 163.000000)">
          <g>
            <path d="M0.55,10.45 L10.45,10.45 L10.45,0.55 L0.55,0.55 L0.55,10.45 Z" />
            <path d="M0.55,20.45 L10.45,20.45 L10.45,10.55 L0.55,10.55 L0.55,20.45 Z" />
            <path d="M0.55,30.45 L10.45,30.45 L10.45,20.55 L0.55,20.55 L0.55,30.45 Z" />
            <path d="M10.55,10.45 L20.45,10.45 L20.45,0.55 L10.55,0.55 L10.55,10.45 Z" />
            <path d="M20.55,10.45 L30.45,10.45 L30.45,0.55 L20.55,0.55 L20.55,10.45 Z" />
            <path d="M10.55,20.45 L20.45,20.45 L20.45,10.55 L10.55,10.55 L10.55,20.45 Z" />
            <path d="M10.55,30.45 L20.45,30.45 L20.45,20.55 L10.55,20.55 L10.55,30.45 Z" />
            <path d="M20.55,20.45 L30.45,20.45 L30.45,10.55 L20.55,10.55 L20.55,20.45 Z" />
            <path d="M20.55,30.45 L30.45,30.45 L30.45,20.55 L20.55,20.55 L20.55,30.45 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconMobileGrid3x;
